export default {
    title: "",
    unavailable: "Questo prodotto non è più disponibile."
}